<template>
    <div :class="wrapClass"
         style="width:100%;">
        <span class="input-group-addon" v-if="!isVertical && ((label && label.length>0)||icon.length>0)">
            <i class="zmdi" v-bind:class="icon" v-if="hasIcon"></i>
            <span v-if="hasLabel" class="gray" :class="{'p-10':hasIcon}"
                  v-html="label"></span>
        </span>
        <div class="fg-line" v-bind:class="{'fg-toggled': ifocus}">
            <input :type="type" class="form-control" :value="value"
                   v-on:input="updateValue($event.target.value)" :placeholder="!isVertical?placeholder:''"
                   v-on:focus="_p_focus" v-on:blur="_p_blur" v-bind:disabled="!isEnabled" v-bind:readonly="isReadOnly"
                   v-bind:style="{'background-color':(isReadOnly&&!isVertical)?'#FFF':''}" v-focus="isOnFocus" />
            <label v-if="isVertical" class="fg-label">
                <i class="zmdi" v-bind:class="icon" v-if="hasIcon"></i>
                <span v-html="label"></span>
            </label>
        </div>
        <div v-if="validator">
            <span class="zmdi zmdi-alert-triangle form-control-feedback" v-show=" hasValidFail "
                  data-placement="bottom" style="width:5px;"></span>
            <span class="zmdi zmdi-check form-control-feedback"
                  v-if=" hasValidSuccess "
                  style="width:5px;"></span>
        </div>
    </div>
</template>
<script>
    import vue from 'vue';
    import mixins from '../../mixins/control-mixins';
    import valid from '../../mixins/control-valid';
    export default {
        name: 'c-textbox',
        mixins: [mixins, valid],
        data() {
            return {
                controlType: 'textbox',
                ifocus: false
            };
        },
        props: {
            value: {
                required: true,
                default: function () {
                    return '';
                }
            },
            type: {
                default: function () {
                    return 'text';
                }
            },
            isOnFocus: {
                default: false
            }
        },
        computed: {
            wrapClass(){
                return {
                    'form-group fg-float m-t-20': this.isVertical,
                    'input-group': !this.isVertical,
                    'disabled': !this.isEnabled,
                    'has-warning': this.validator && !this.Valid_Status__,
                    'has-success': this.hasSuccess
                }
            },
            hasIcon(){
                return this.icon && this.icon.length > 0;
            },
            hasLabel(){
                return this.label && this.label.length > 0;
            },
            hasValidSuccess(){
                return this.validator && this.Valid_Status__ && this.value !== null && this.value !== undefined && this.value.toString().length > 0;
            },
            hasValidFail(){
                return this.validator && !this.Valid_Status__;
            },
            hasValue: function () {
                return this.value || this.value === 0;
            }
        },
        mounted: function () {
        },
        methods: {
            _p_focus: function () {
                this.ifocus = true;
                this.$emit('focus', arguments);
            },
            _p_blur: function () {
                this.ifocus = false;
                this.$emit('blur', arguments);
            },
            updateValue: function (value) {
                this.$emit('input', value);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// textbox.vue?e8ea108e